import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomToastsService {
  private _successMessage: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private _processMessage: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private _errorMessage: BehaviorSubject<string> = new BehaviorSubject<string>(
    ''
  );
  private _clientErrorMessage: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private _serverErrorMessage: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private _warningMessage: BehaviorSubject<string> =
    new BehaviorSubject<string>('');
  private _qzPermissionModal: BehaviorSubject<string> =
    new BehaviorSubject<string>('');

  constructor() {}

  success(msg: string) {
    this._successMessage.next(msg);
    this._processMessage.next(''); // Clear the process message
    setTimeout(() => {
      this._successMessage.next('');
    }, 3000);
  }

  showSuccess(msg: string) {
    this._successMessage.next(msg);
    this._processMessage.next(''); // Clear the process message
  }

  error(msg: string) {
    this._errorMessage.next(msg);
    setTimeout(() => {
      this._errorMessage.next('');
    }, 3000);
  }

  showError(msg: string) {
    this._errorMessage.next(msg);
    setTimeout(() => {
      this._errorMessage.next('');
    }, 3000);
  }

  clientError(msg: string, statusCode?: number) {
    const prefixedMessage = statusCode ? `[${statusCode}] ${msg}` : msg;
    this._clientErrorMessage.next(prefixedMessage);
    setTimeout(() => {
      this._clientErrorMessage.next('');
    }, 5000); // Longer timeout for error messages
  }

  serverError(msg: string, statusCode?: number) {
    const prefixedMessage = statusCode ? `[${statusCode}] ${msg}` : msg;
    this._serverErrorMessage.next(prefixedMessage);
    setTimeout(() => {
      this._serverErrorMessage.next('');
    }, 5000); // Longer timeout for error messages
  }

  warning(msg: string) {
    this._warningMessage.next(msg);
    setTimeout(() => {
      this._warningMessage.next('');
    }, 4000);
  }

  process(msg: string) {
    this._processMessage.next(msg);
  }

  get successMessage$() {
    return this._successMessage.asObservable();
  }

  get errorMessage$() {
    return this._errorMessage.asObservable();
  }

  get processMessage$() {
    return this._processMessage.asObservable();
  }

  get clientErrorMessage$() {
    return this._clientErrorMessage.asObservable();
  }

  get serverErrorMessage$() {
    return this._serverErrorMessage.asObservable();
  }

  get warningMessage$() {
    return this._warningMessage.asObservable();
  }

  showQzPermissionModal(msg: string) {
    this._qzPermissionModal.next(msg);
  }

  hideQzPermissionModal() {
    this._qzPermissionModal.next('');
  }

  get qzPermissionModal$() {
    return this._qzPermissionModal.asObservable();
  }
}
